import { z } from 'zod/v3';

export const configurationProfilesFiltersSchema = z.object({
  name: z.string().optional(),
  clientId: z.string().optional(),
  status: z.string().optional(),
  technologyId: z.string().optional(),
  createdAtRange: z
    .object({
      from: z.date().optional(),
      to: z.date().optional(),
    })
    .optional(),
  editedAtRange: z
    .object({
      from: z.date().optional(),
      to: z.date().optional(),
    })
    .optional(),
});

export type ConfigurationProfilesFiltersFormData = z.infer<
  typeof configurationProfilesFiltersSchema
>;
